import { render } from "./pagerduty.vue?vue&type=template&id=58d7dbf1"
import script from "./pagerduty.vue?vue&type=script&lang=js"
export * from "./pagerduty.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__